// src/pages/projects/Survey.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectDetail.module.css';

import one from '../../assets/1.png';
import two from '../../assets/2.png';
import three from '../../assets/3.png';

import survey1 from '../../assets/survey1.png';
import survey2 from '../../assets/survey2.png';
import survey3 from '../../assets/survey3.png';
import survey4 from '../../assets/survey4.png';
import survey5 from '../../assets/survey5.png';
import survey6 from '../../assets/survey6.png';
import survey7 from '../../assets/survey7.png';
import survey8 from '../../assets/survey8.png';
import survey9 from '../../assets/survey9.png';
import survey10 from '../../assets/survey10.png';
import survey11 from '../../assets/survey11.png';
import survey12 from '../../assets/survey12.png';
import survey13 from '../../assets/survey13.png';
import survey14 from '../../assets/survey14.png';
import survey15 from '../../assets/survey15.png';

const images = [
  one, two, three,
  survey1, survey2, survey3, survey4, survey5, survey6,
  survey7, survey8, survey9, survey10, survey11,
  survey12, survey13, survey14, survey15
];

export default function Survey() {
  const [current, setCurrent] = useState(0);

  const nextImage = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Online Survey System</h1>

      <div className={styles.carousel}>
        <button onClick={prevImage} className={styles.navBtn}>❮</button>
        <img
          src={images[current]}
          alt={`Survey Screenshot ${current + 1}`}
          className={`${styles.carouselImage} ${styles.fadeIn}`}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <button onClick={nextImage} className={styles.navBtn}>❯</button>
      </div>

      <p className={styles.description}>
        The <strong>Online Survey System</strong> is a full-stack web application developed using <strong>Java (JSP & Servlets)</strong> and <strong>MySQL</strong>. Built with the goal of improving decision-making at <strong>Wachemo University</strong>, the platform simplifies how surveys are created, distributed, and analyzed for employee and student feedback.
      </p>

      <p className={styles.description}>
        <strong>Admin Panel Highlights:</strong><br />
        • Secure login for the administrator<br />
        • <strong>Add new users</strong> (employees or participants)<br />
        • <strong>Manage users</strong> with full control (edit/delete)<br />
        • <strong>Create and list surveys</strong> dynamically<br />
        • <strong>Add questions</strong> for each survey<br />
        • <strong>Filter and manage questions</strong> by survey category<br />
        • <strong>View complete survey reports</strong> with real-time summaries
      </p>

      <p className={styles.description}>
        <strong>User Panel Highlights:</strong><br />
        • Login with secure credentials<br />
        • Select from available survey titles<br />
        • Answer survey questions through an intuitive interface<br />
        • Submit feedback easily and effectively
      </p>

      <ul className={styles.features}>
        <li>✅ Admin dashboard with user, survey & question management</li>
        <li>✅ Dynamic survey reports for analysis</li>
        <li>✅ Separate panels for Admin and User</li>
        <li>✅ Responsive and clean user interface</li>
        <li>✅ MySQL-backed secure data storage</li>
      </ul>

      <div className={styles.buttonGroup}>
        <Link to="/" className={styles.backBtn}>← Back to Home</Link>
      </div>
    </div>
  );
}
